import React from 'react'
import { InputGroup, Label, Input } from 'reactstrap'

export default function Username({val, oChg, err, saved}) {
  return (
    <InputGroup>
      <Label htmlFor='username'>Username:</Label>
      <Input 
        type='text'
        onChange={oChg}
        value={val}
        name='username'
        id='username'
        invalid={!!err.username}
        disabled={!!saved}
      />
      </InputGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/Username.js